export const WIDGET_IDS = {
  PHI_HEADER: 'phi-header', // For non-home page usage of EQ widget
  PHI_HOME: 'phi-home',
  TRAVEL: 'travel',
} as const;

export type WidgetId = (typeof WIDGET_IDS)[keyof typeof WIDGET_IDS];

export const SESSION_STORAGE_KEYS = {
  FORMIK_STATE: 'embedded-widget-state',
  TRAVELLER_COUNT: 'embedded-widget-amount-of-travellers',
};
